module.exports = __webpack_public_path__ + "static/about-huge-3-ae6f9b484c9f48b7a4528156cbf11858.jpg";